import React from 'react';
import { Space, Table, Tooltip } from 'antd';
import CoaHeader from '../Header';
import { CoaRecord, CoaTableProps } from './type';
import { DeleteActionSvg, EditActionSvg } from 'utils/svgs';
import styles from './index.module.scss';

const { Column } = Table;

const renderScopeCell = (
	ids: string[] | undefined,
	labelById: Map<string, string>,
	labelPrefix: 'Branch' | 'Department',
) => {
	if (!ids?.length) {
		return <span>-</span>;
	}

	const labels = ids.map((id) => labelById.get(id) ?? id);

	const tooltipContent = (
		<ul className={styles['scope-tooltip-list']}>
			{labels.map((label) => (
				<li key={label}>{label}</li>
			))}
		</ul>
	);

	return (
		<Tooltip
			title={tooltipContent}
			color="#fff"
			overlayInnerStyle={{ color: '#1a1a1a' }}
		>
			<span className={styles['scope-count']}>
				{labelPrefix}({labels.length})
			</span>
		</Tooltip>
	);
};

const CoaTable: React.FC<CoaTableProps> = (props) => {
	const {
		data,
		loading,
		totalRecords,
		currentPage,
		paginationChangeHandler,
		onEdit,
		onDelete,
		branchLabelById,
		departmentLabelById,
		searchValue,
		handleSearch,
		handleSearchApi,
		typeFilter,
		onTypeChange,
		branchFilter,
		onBranchChange,
		branchOptions,
		departmentFilter,
		onDepartmentChange,
		departmentOptions,
		isDropdownLoading,
	} = props;

	return (
		<div className={styles['dynamic-table']}>
			<CoaHeader
				searchValue={searchValue}
				handleSearch={handleSearch}
				handleSearchApi={handleSearchApi}
				typeFilter={typeFilter}
				onTypeChange={onTypeChange}
				branchFilter={branchFilter}
				onBranchChange={onBranchChange}
				branchOptions={branchOptions}
				departmentFilter={departmentFilter}
				onDepartmentChange={onDepartmentChange}
				departmentOptions={departmentOptions}
				isDropdownLoading={isDropdownLoading}
			/>
			<Table<CoaRecord>
				dataSource={data}
				loading={loading}
				rowKey="id"
				scroll={{ y: 'calc(100vh - 360px)' }}
				pagination={{
					total: totalRecords,
					current: currentPage,
					onChange: paginationChangeHandler,
					defaultPageSize: 10,
					showSizeChanger: false,
					pageSizeOptions: [10, 20, 50, 100, 200],
				}}
			>
				<Column
					title="Account Number"
					dataIndex="accountNo"
					key="accountNo"
					className="bg-white"
				/>
				<Column
					title="COA Name"
					dataIndex="name"
					key="name"
					className="bg-white"
				/>
				<Column title="Type" dataIndex="type" key="type" className="bg-white" />
				<Column
					title="Description"
					dataIndex="desc"
					key="desc"
					className="bg-white"
					render={(text: string) => <span>{text || '-'}</span>}
				/>
				<Column
					title="Branch"
					dataIndex="branchIds"
					key="branchIds"
					className="bg-white"
					render={(branchIds: string[]) =>
						renderScopeCell(branchIds, branchLabelById, 'Branch')
					}
				/>
				<Column
					title="Department"
					dataIndex="departmentIds"
					key="departmentIds"
					className="bg-white"
					render={(departmentIds: string[]) =>
						renderScopeCell(
							departmentIds,
							departmentLabelById,
							'Department',
						)
					}
				/>
				<Column
					title="Action"
					key="action"
					className="bg-white"
					render={(_: unknown, record: CoaRecord) => (
						<Space size={20}>
							<div
								className="cursor-pointer flex align-center justify-center"
								onClick={() => onEdit(record)}
							>
								<EditActionSvg />
							</div>
							<div
								className="cursor-pointer flex align-center justify-center"
								onClick={() => onDelete(record)}
							>
								<DeleteActionSvg />
							</div>
						</Space>
					)}
				/>
			</Table>
		</div>
	);
};

export default CoaTable;
